var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { OperationContext, State } from '../../services/operation.context';
import { ModalConfirmationService } from '../../services/confirmation.service';
import { Router } from '@angular/router';
import { AdalService } from 'adal-angular4';
var DELETE = 46;
var LEFT = 37;
var RIGHT = 39;
var ImageSlideComponent = /** @class */ (function () {
    function ImageSlideComponent(operationContext, modalService, router, adal) {
        this.operationContext = operationContext;
        this.modalService = modalService;
        this.router = router;
        this.adal = adal;
    }
    ImageSlideComponent.prototype.ngOnInit = function () {
        this.renderer.update(this.operationContext.selectedImage);
    };
    ImageSlideComponent.prototype.handleKeydown = function (event) {
        if (this.operationContext.state != State.IDLE) {
            return;
        }
        switch (event.keyCode) {
            case DELETE: {
                if (event.ctrlKey) {
                    event.preventDefault();
                    this.deleteItem();
                }
                break;
            }
            case LEFT: {
                event.preventDefault();
                this.previous();
                break;
            }
            case RIGHT: {
                event.preventDefault();
                this.next();
                break;
            }
        }
    };
    ImageSlideComponent.prototype.isDisabled = function () {
        return !(this.operationContext.images || this.operationContext.selectedCollection);
    };
    ImageSlideComponent.prototype.deleteItem = function () {
        if (!this.operationContext.selection) {
            return;
        }
        this.operationContext.selectedImage.deleteTag(this.operationContext.selection.selectedItem.parent());
        this.operationContext.clearSelection();
    };
    ImageSlideComponent.prototype.previous = function () {
        this.slideImages(1);
    };
    ImageSlideComponent.prototype.next = function () {
        this.slideImages(0);
    };
    ImageSlideComponent.prototype.slideImages = function (direction) {
        return __awaiter(this, void 0, void 0, function () {
            var enabledImageItems, images, index;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Uncheck inspiration feed
                        this.operationContext.inspirationalParentCheck = false;
                        this.operationContext.inspirationalCropCheck = false;
                        if (this.operationContext.state != State.IDLE) {
                            console.log("IDLE");
                            return [2 /*return*/];
                        }
                        if (!this.adal.userInfo.authenticated) {
                            this.router.navigate(['splash']);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.checkChanges()];
                    case 1:
                        if (_a.sent()) {
                            console.log("checkedChanges");
                            return [2 /*return*/];
                        }
                        enabledImageItems = this.operationContext.images
                            .filter(function (image) {
                            return _this.operationContext.stateFilter[image.state];
                        });
                        if (!enabledImageItems ||
                            enabledImageItems.length === 0 ||
                            this.operationContext.selectedCollection == null) {
                            return [2 /*return*/];
                        }
                        images = enabledImageItems
                            .map(function (image) { return image.id; });
                        index = images.indexOf(this.operationContext.selectedImage.id);
                        if (direction) {
                            index--;
                        }
                        else {
                            index++;
                        }
                        if (index >= enabledImageItems.length) {
                            index = 0;
                        }
                        else if (index < 0) {
                            index = enabledImageItems.length - 1;
                        }
                        this.renderer.update(enabledImageItems[index]);
                        return [2 /*return*/];
                }
            });
        });
    };
    ImageSlideComponent.prototype.checkChanges = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.operationContext.isModified) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.modalService.confirm({
                                title: 'Unsaved changes',
                                otherData: 'Do you want to continue without saving and lose all changes?'
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2: return [2 /*return*/, false];
                }
            });
        });
    };
    return ImageSlideComponent;
}());
export { ImageSlideComponent };
